import { SITE_URL, SITE_NAME } from "../../content/site"
import { company } from "../../content/company"

/** Organization schema — only verified information, sourced from company.ts. */
export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: company.name,
    url: SITE_URL,
    logo: `${SITE_URL}${company.logo}`,
    address: {
      "@type": "PostalAddress",
      addressLocality: company.displayLocation.city,
      addressRegion: company.displayLocation.region,
      addressCountry: "NL",
    },
    sameAs: [
      company.socialProfiles.linkedin,
      company.socialProfiles.instagram,
      company.socialProfiles.facebook,
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: company.email,
        telephone: company.phoneNumbers.map((p) => p.href.replace("tel:", "")),
        availableLanguage: ["nl", "en"],
      },
    ],
    founder: company.founders.map((f) => ({
      "@type": "Person",
      name: f.name,
      jobTitle: f.role.en,
    })),
  }
}

export function buildWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    publisher: {
      "@type": "Organization",
      name: company.name,
      url: SITE_URL,
    },
    inLanguage: ["nl-NL", "en"],
  }
}
